import React from "react";
import { useParams } from "react-router-dom";
import algoliasearch from "algoliasearch";

import {
  Container,
  Typography,
  Avatar,
  Dialog,
  Fab,
  Slide,
  CircularProgress,
  Grid,
} from "@material-ui/core";

import FingerprintIcon from "@material-ui/icons/Fingerprint";

import { Group, normaliseGroupScore } from "../Home/Group";
import { ScoreView } from "../Utilities/ScoreView";
import { MEPHighscoreCard } from "../Utilities/MEPHighscoreCard";
import { MEP } from "../Home/MEP";

const client = algoliasearch("V7NYNJIM7C", "439a81efb8f918ee5bf3b0380b0f9f28");

const Transition = React.forwardRef(function Transition(props, ref) {
  // @ts-ignore
  return <Slide direction="up" ref={ref} {...props} />;
});

export const GroupDetails: React.FC = () => {
  const [index] = React.useState(client.initIndex("groups"));
  const [mepIndex] = React.useState(client.initIndex("meps"));

  const { id } = useParams<{ id: string }>();
  const [group, setGroup] = React.useState<Group>();
  const [meps, setMeps] = React.useState<MEP[]>();

  const [fingerPrintOpen, setFingerPrintOpen] = React.useState(false);

  React.useEffect(() => {
    const getMep = async () => {
      const theGroup = await index.getObject<Group>(id);

      setGroup(theGroup);
      setMeps(
        (await mepIndex.search("", { filters: `group:"${theGroup.group}"` }))
          .hits as MEP[]
      );
    };

    getMep();
  }, [mepIndex, index, id]);

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  if (!group)
    return (
      <div
        style={{
          marginTop: "20px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress />;
      </div>
    );

  return (
    <div>
      <Dialog
        open={fingerPrintOpen}
        // @ts-ignore
        TransitionComponent={Transition}
        keepMounted
        onClose={() => setFingerPrintOpen(false)}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
        maxWidth="lg"
      >
        <img
          src={`https://storage.googleapis.com/futurereadinessindex.appspot.com/organization_fingerprints/wcgp_${group.clean_group}_large.png`}
          style={{ width: "500px", height: "500px", objectFit: "none", margin: "0 auto" }}
          alt="Political Fingerprint"
        />
        <Typography variant="caption" align="center">
          Political fingerprint of {group.group}
        </Typography>
      </Dialog>

      <div className="top-area">
        <div className="mep-profile-card">
          <Avatar
            src={`https://storage.googleapis.com/futurereadinessindex.appspot.com/groups_logos/${group.clean_group}.png`}
            alt={group.group}
            style={{
              height: "150px",
              width: "150px",
              marginTop: "20px",
              marginBottom: "20px",
            }}
          />
          <Typography variant="h5" gutterBottom align="center">
            {group.group}
          </Typography>

          <div style={{ marginTop: "20px", marginBottom: "20px" }}>
            <Fab
              color="secondary"
              aria-label="political-fingerprint"
              onClick={() => setFingerPrintOpen(true)}
            >
              <FingerprintIcon />
            </Fab>
          </div>
        </div>
        <div style={{ padding: "20px" }}>
          <ScoreView
            score={group.score}
            scoreNormalised={normaliseGroupScore(group.score)}
          />
        </div>
      </div>
      <Container maxWidth={false}>
        <Grid container alignItems="center" wrap="nowrap">
          <Grid item>
            <Typography
              variant="h6"
              style={{ marginTop: "20px", marginBottom: "20px" }}
            >
              Top scores from {group.group}
            </Typography>
          </Grid>
        </Grid>
        <Grid container spacing={1}>
          {meps?.map((mep) => (
            <MEPHighscoreCard key={mep.objectID} mep={mep} />
          ))}
        </Grid>
      </Container>
    </div>
  );
};
